import {useState} from "react";
import "./footer.css";
import InstagramIcon from "../icons/Instagram/instagram";
import RedIcon from "../icons/red/red";
import ShareIcon from "../icons/share/share";
import { useTranslation } from "../../i18n";
import { useWhiteLabel } from "../../whiteLabel/useWhiteLabel";
import { useLocation } from "react-router-dom";
import { shouldHideInstagramRedIcons } from "../title/indexIconsConfig";

function Footer() {
    const [currentYear] = useState(new Date().getFullYear());
    const { t } = useTranslation();
    const { isWhiteLabel } = useWhiteLabel();
    const { pathname } = useLocation();
    const hideInstagramRed = shouldHideInstagramRedIcons(pathname);

    if (isWhiteLabel) {
        return null;
    }

    return (
        <footer>
            <div className={"footer-icons"}>
                {!hideInstagramRed && <InstagramIcon/>}
                {!hideInstagramRed && <RedIcon/>}
                <ShareIcon/>
            </div>
            <p>{t("common.copyright", { year: currentYear })}</p>
        </footer>
    );
}

export default Footer;
